import React from 'react';
import Select from 'react-select';

export default function CustomSelect({
  options = [],
  value = '',
  onChange = () => {},
  className = '',
  placeholder = 'Select an option',
  ...props
}) {
  const selectedOption = options.find(option => option.value === value) || null;

  const selectStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    control: (base, state) => ({
      ...base,
      width: '100%',
      borderRadius: '8px',
      backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
      borderColor: state.isFocused ? '#86b7fe' : '#929398',
      boxShadow: state.isFocused
        ? '0 0 0 0.15rem rgba(13,110,253,.25)'
        : 'none',
      transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',
      '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#ced4da' },
      cursor: state.isDisabled ? 'not-allowed' : 'default',
    }),
    valueContainer: base => ({
      ...base,
      padding: '0.255rem 0.75rem',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? '#212529' : '#212529',
      paddingRight: '0.75rem',
      paddingLeft: 0,
      '&:hover': { color: '#212529' },
    }),
    menu: base => ({
      ...base,
      borderRadius: '0.375rem',
      overflow: 'hidden',
      boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)',
      border: '1px solid #ced4da',
    }),
    placeholder: base => ({
      ...base,
      color: '#6c757d',
    }),
    singleValue: base => ({
      ...base,
      color: '#212529',
    }),
    container: base => ({
      ...base,
      width: '100%',
    }),
  };

  const menuPortalTarget =
    typeof document !== 'undefined' ? document.body : null;

  return (
    <Select
      className={className}
      classNamePrefix="react-select"
      options={options}
      value={selectedOption}
      onChange={selected => onChange(selected ? selected.value : '')}
      placeholder={placeholder}
      isClearable
      styles={selectStyles}
      menuPortalTarget={menuPortalTarget}
      {...props}
      noOptionsMessage={() => null}
    />
  );
}
